/* eslint-disable arrow-body-style */
import { DiscountType } from '@models/ropolo';
import { OfflineOrderingState } from '../types';

const removeDiscountFactorDetails = (state: OfflineOrderingState): OfflineOrderingState => {
  return {
    ...state,
    discountType: DiscountType.MONEY,
    discountAmount: 0,
  };
};

export default removeDiscountFactorDetails;
